import { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import GlobalStates from "../../layouts/GlobalStates";
import AppContent from "../../layouts/AppContent";
import { ConfigProvider } from "antd";
import "../../styles/variables.scss";
import { useTranslation } from "react-i18next";

export const App = () => {
    const {
        i18n: { dir, language, changeLanguage },
    } = useTranslation();

    useEffect(() => {
        const body = document.body;
        const documentDirection = dir(language);
        body.dir = documentDirection;
        document.documentElement.dir = documentDirection;
        document.documentElement.lang = language || "fa";
    }, [language, dir]);
    useEffect(() => {
        const storedLanguage = localStorage.getItem("activeLanguage");
        if (storedLanguage) {
            changeLanguage(storedLanguage);
        }
    }, [changeLanguage]);

    return (
        <GlobalStates>
            <ConfigProvider direction={dir(language)}>
                <AppContent />
            </ConfigProvider>
        </GlobalStates>
    );
};
